import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {StockTakeSearchPageComponent} from "../stock-take-search-page/stock-take-search-page.component";
import {StockTakeSearchModel} from "../stock-take-search.model";

@Component({
    selector: "wbo-stock-take-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(StockTakeSingleSelectEditControl),
        provideSearchModel(StockTakeSearchModel)
    ]
})
export class StockTakeSingleSelectEditControl extends AbstractSingleSelectEditControlComponent<StockTakeSearchModel> {
    constructor(model: StockTakeSearchModel, injector: Injector) {
        super(model, injector, "stockTakeId", "name");

        this.extendedSearchComponent = StockTakeSearchPageComponent;
        this.extendedEditComponent = StockTakeSearchPageComponent;
    }
}
